import { render, staticRenderFns } from "./ConfigureExport.vue?vue&type=template&id=508f0bfe"
import script from "./ConfigureExport.vue?vue&type=script&lang=js"
export * from "./ConfigureExport.vue?vue&type=script&lang=js"
import style0 from "./ConfigureExport.vue?vue&type=style&index=0&id=508f0bfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
